import { ApolloProvider } from "@apollo/client";
import { PropsWithChildren } from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";

import { client } from "@client";
import { useTheme } from "@hooks";
import { HomeTokenSet, homeDark, homeLight } from "@layout/theme/homeTokens";

const cssVars = (tokens: HomeTokenSet) =>
  Object.entries(tokens)
    .map(([key, value]) => `--hm-${key}: ${value};`)
    .join("\n");

/**
 * The design-system mesh paints the page ground for every themed screen,
 * and the --hm-* tokens are declared globally so any component can use
 * them in either theme.
 */
const GlobalGround = createGlobalStyle<{ $dark: boolean }>`
  :root {
    ${({ $dark }) => cssVars($dark ? homeDark : homeLight)}
  }

  body {
    background: ${({ $dark }) => ($dark ? homeDark.mesh : homeLight.mesh)};
    background-attachment: fixed;
  }
`;

export const Providers = ({ children }: PropsWithChildren) => {
  const { theme } = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <GlobalGround $dark={theme.meta.dark} />
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </ThemeProvider>
  );
};
